import { patientName } from 'Data/format.js'

export function format(person, hipaa) {
  return `${patientName({
    ...person,
    last_name: !hipaa && person.last_name,
  })}`
}
